import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import moment from "moment";
import { connect } from "react-redux";
import Pagination from "../../../utils/pagination";
import { toastError, toastSuccess, centerActionId, organizersActionId, deliveryStatusActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import DatePicker from 'react-datepicker';
import { fill_action } from "../../../actions/fillList_action"
import Workbook from 'react-excel-workbook'
import Header from '../../../common_components/Header';
import { get_block_calendar_list_action, unblock_calender_action } from "../../../actions/calender_actions/calender_action";
import Modal from 'react-bootstrap/Modal';


class UnblockCalenderList extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            blockCalendarList: [],
            isAccordionExpanded: false,
            // orderNo: '',
            clientName: '',
            centerID: '',
            centerList: [],
            centerName: '',
            // startDate: '',
            date: '',
            // endDate: '',
            isOpen: false,
            currentOrder: '',
            selectedList: [],
        }

        // this.renderSlotsTable = this.renderSlotsTable.bind(this)
        this.renderTable = this.renderTable.bind(this)
        this.getBlockedCalenderlist = this.getBlockedCalenderlist.bind(this)
        this.getFillList = this.getFillList.bind(this)
        // this.formatData = this.formatData.bind(this)
        this.clearFilters = this.clearFilters.bind(this)
        this.onCheckboxClick = this.onCheckboxClick.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        // this.onAdd = this.onAdd.bind(this)
        this.updateItem = this.updateItem.bind(this)
        // this.onCheckboxClick = this.onCheckboxClick.bind(this)
        // this.renderSelectedTable = this.renderSelectedTable.bind(this)
        this.handleunblockCalender = this.handleunblockCalender.bind(this)
    }

    componentDidMount() {
        // this.getExhibitionManualForm()
        this.getFillList(centerActionId, '').then(res => {
            res && this.getBlockedCalenderlist()
        })
        // this.getFillList(organizersActionId, '')
        // this.getFillList(deliveryStatusActionId, '')
    }

    handleunblockCalender() {
        const { blockCalendarList } = this.state
        var arr = []
        blockCalendarList.map((item => {
            item.isSelect && arr.push(item)
        }))
        this.setState({ isLoading: true })
        this.props.unblock_calender_action(arr)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("unblocked Successfully")
                    setTimeout(() => {
                        this.toggleModal()
                        this.getBlockedCalenderlist()
                        this.setState({ isLoading: false })
                    }, 200);

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    toggleModal() {
        const { currentOrder, blockCalendarList, isOpen, currentSelectedSlotsList } = this.state
        this.setState({ isOpen: !isOpen })
    }

    getFillList(value, userID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(value, (userID == '' || userID == null) ? null : userID)
                .then((data) => {
                    if (data.error != 1) {
                        if (value == centerActionId) {
                            var list = []
                            data.data.length > 0 && data.data.map((item) => {
                                item.ParentCenterID == 0 && list.push(item)
                            })
                            this.setState({ centerList: list })
                        }
                        resolve(true)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    clearFilters() {
        const { orderNo, centerID, startDate, date, endDate, clientName } = this.state
        this.setState({
            // orderNo: '',
            centerID: '',
            // startDate: '',
            // endDate: '',
            date: '',
            clientName: '',
        })
        setTimeout(() => {
            this.getBlockedCalenderlist()
        }, 200);
    }

    getBlockedCalenderlist() {
        const { orderNo, centerID, startDate, date, blockCalendarList, selectedList, endDate, clientName } = this.state
        this.setState({ isLoading: true })
        this.props.get_block_calendar_list_action(centerID, date, clientName)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    var list = data.data
                    list.length > 0 ? list.map(item => {
                        item.isSelect = false
                    }) && this.setState({ blockCalendarList: list }) : this.setState({ blockCalendarList: [], selectedList: [] })
                    this.setState({ isLoading: false })
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toastError(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onCheckboxClick(e, data) {
        const { blockCalendarList, selectedList } = this.state
        if (!data.isSelect) {
            selectedList.push(data.CalendarID)
            data.isSelect = true
        } else {
            for (var i = 0; i < selectedList.length; i++) {
                if (selectedList[i] == data.CalendarID) {
                    selectedList.splice(i, 1)
                }
            }
            data.isSelect = false
        }
        this.setState({ blockCalendarList: blockCalendarList, selectedList: selectedList })
    }

    renderTable(currentList) {
        const { blockCalendarList } = this.state
        return (
            <>
                <div className="table-responsive mb-4 ">
                    <table className="table  table-bordered table-striped  mb-0 mt-1">
                        <thead>
                            <tr key={Math.random()}>
                                <th style={{ width: '60px' }}></th>
                                <th className="text-center">Company Name</th>
                                <th className="text-center">ITME Center</th>
                                <th className="text-center">Blocked Date</th>
                                <th className="text-center">Time Slot</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                currentList.length > 0 ?
                                    currentList.map((data, i) => (
                                        <tr key={i}>
                                            <td style={{ width: '60px' }} className="text-center">
                                                <input style={{ display: 'inline' }} type="checkbox" className="only_checkbox"
                                                    // disabled={data.StatusID == '1' || data.StatusID == '2'}
                                                    value={data.isSelect}
                                                    checked={data.isSelect}
                                                    onChange={(e) => this.onCheckboxClick(e, data)}
                                                />
                                            </td>
                                            <td className="text-center">{data.ClientName}</td>
                                            <td className="text-center">{data.Center}</td>
                                            <td className="text-center">{moment(data.SlotDate).format('DD-MM-YYYY')}</td>
                                            <td className="text-center">{data.TimeSlot}</td>
                                        </tr>
                                    )) : <tr><td colSpan={12} style={{ textAlign: 'center' }}>Record not found</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

    updateItem(item) {
        this.setState({ currentPage: item });
    }

    render() {
        const { isLoading, isOpen, blockCalendarList, orderNo, clientName, selectedSlotsList, centerID, currentOrder, date, centerList, centerName, startDate, endDate, isAccordionExpanded, selectedList, currentPage } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = blockCalendarList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(blockCalendarList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <main id="main">
                    <Header
                        data={[8]}
                    />
                    <section style={{ marginTop: '115px' }}>
                        <div className="container-fluid">
                            <div className="page-header ml-4 mb-n2">
                                <h4 className="page-title">Blocked Calendar slots</h4>
                            </div>
                            <div className="card-body">
                                <div className="search_accordion search_card">
                                    <div className="panel-group" id="accordion">
                                        <div className="panel panel-default">
                                            <div
                                                className="panel-heading accordion-toggle collapsed"
                                                data-toggle="collapse"
                                                data-parent="#accordion"
                                                data-target="#collapseOne"
                                                aria-expanded={isAccordionExpanded}
                                                onClick={() =>
                                                    this.setState({
                                                        isAccordionExpanded: !isAccordionExpanded,
                                                    })
                                                }
                                            >
                                                <h4 className="panel-title">Search</h4>
                                                <div className="searched_items">
                                                    {/* {orderNo != '' && orderNo != null &&
                                                        <h5>
                                                            Order No. : <span>{orderNo}</span>
                                                        </h5>
                                                    } */}
                                                    {clientName != '' && clientName != null &&
                                                        <h5>
                                                            Company Name : <span>{clientName}</span>
                                                        </h5>
                                                    }
                                                    {centerList.length > 0 && centerList.map(item => (<>
                                                        {
                                                            item.CenterID == centerID &&
                                                            <h5>
                                                                Center Name : <span>{item.Name}</span>
                                                            </h5>
                                                        }
                                                    </>
                                                    ))
                                                    }
                                                    {date != '' && date != null &&
                                                        <h5>
                                                            Date :{" "}
                                                            <span>{moment(date).format('DD-MM-YYYY')}</span>
                                                        </h5>
                                                    }

                                                    {/* <div class="chip">
              John Doe <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
            </div> */}
                                                </div>
                                            </div>
                                            <div
                                                id="collapseOne"
                                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                    }`}
                                                aria-labelledby="headingOne"
                                            >
                                                <div className="panel-body">
                                                    <div className="row mr_0">
                                                        {/* <div className="col-md-2 ml-4">
                                                            <div className="form-group">
                                                                <label>Order No.</label>
                                                                <input
                                                                    className="form-control"
                                                                    value={orderNo}
                                                                    onChange={(e) => {
                                                                        this.setState({ orderNo: e.target.value })
                                                                    }} />
                                                            </div>
                                                        </div> */}
                                                        <div className="col-md-2 ml-4">
                                                            <div className="form-group">
                                                                <label>Company Name</label>
                                                                <input
                                                                    className="form-control"
                                                                    value={clientName}
                                                                    onChange={(e) => {
                                                                        this.setState({ clientName: e.target.value })
                                                                    }} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 ml-4">
                                                            <div className="form-group">
                                                                <label>Center</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={centerID}
                                                                    onChange={(e) => {
                                                                        this.setState({ centerID: e.target.value })
                                                                    }}
                                                                >
                                                                    <option value={''}>Select</option>
                                                                    {centerList.length > 0 ? centerList.map(data => (
                                                                        <option
                                                                            key={data.CenterID}
                                                                            value={data.CenterID}>
                                                                            {data.Name}
                                                                        </option>
                                                                    )) : <></>}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 ml-4">
                                                            <div className="form-group">
                                                                <label>Date</label>
                                                                <DatePicker className={"form-control text-dark"}
                                                                    dateFormat="dd-MM-yyyy"
                                                                    selected={date}
                                                                    onChange={(date) => {
                                                                        this.setState({ date: date })
                                                                    }}
                                                                    // maxDate={endDate}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="Date"
                                                                // customInput={<ExampleCustomInput />}
                                                                // dayClassName={() => "example-datepicker-day-class"}
                                                                // popperClassName="example-datepicker-class"
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-md-2 ml-4">
                                                            <div className="form-group">
                                                                <label>From Date</label>
                                                                <DatePicker className={"form-control text-dark"}
                                                                    dateFormat="dd-MM-yyyy"
                                                                    selected={startDate}
                                                                    onChange={(date) => {
                                                                        this.setState({ startDate: date })
                                                                    }}
                                                                    maxDate={endDate}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="From Date"
                                                                // customInput={<ExampleCustomInput />}
                                                                // dayClassName={() => "example-datepicker-day-class"}
                                                                // popperClassName="example-datepicker-class"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 ml-4">
                                                            <div className="form-group">
                                                                <label>To Date</label>
                                                                <DatePicker className={"form-control text-dark"}
                                                                    dateFormat="dd-MM-yyyy"
                                                                    // disabled={statusId != 2 && is_update == true ? true : false}
                                                                    selected={endDate}
                                                                    onChange={(date) => {
                                                                        this.setState({ endDate: date })
                                                                    }}
                                                                    minDate={startDate}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="To Date"
                                                                // customInput={<ExampleCustomInput />}
                                                                // dayClassName={() => "example-datepicker-day-class"}
                                                                // popperClassName="example-datepicker-class"
                                                                />
                                                            </div>
                                                        </div> */}
                                                        <div style={{ width: '100%' }} className="col-md-12">
                                                            <div style={{ float: 'right' }} >
                                                                <label>&nbsp;</label>
                                                                <button
                                                                    onClick={() => this.getBlockedCalenderlist()}
                                                                    className="btn btn-primary search_btn"
                                                                >
                                                                    <i className="fa fa-sliders" />
                                                                    Search
                                                                </button>
                                                                &nbsp;
                                                                <button
                                                                    onClick={() => this.clearFilters()}
                                                                    className="btn btn-primary search_btn"
                                                                >
                                                                    <i className="fa fa-times" />
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row m-2" style={{ float: 'right', right: '0px' }}>
                                <div className="btn-group save-can d-block" role="group" aria-label="Basic example">
                                    <button
                                        type="button"
                                        className="btn btn-warning my_custom_orderPage_btns m-2"
                                        style={{ width: 140, fontSize: 15, }}
                                        onClick={this.onViewClick}
                                    >
                                        View
                                    </button>
                                    {list.length > 0 ? <Workbook filename={`feedback_report.xlsx`} style={{}} element={
                                        <button className="btn btn-success my_custom_orderPage_btns m-2" style={{ width: 140, fontSize: 15 }} >
                                            download
                                        </button>
                                    }>
                                        <Workbook.Sheet data={xlrowArr} name="Sheet A">
                                            {columnArr.map((value, index) =>
                                                <Workbook.Column label={value} value={value} />
                                            )
                                            }
                                        </Workbook.Sheet>
                                    </Workbook>
                                        : <button className="btn btn-success my_custom_orderPage_btns m-2" style={{ width: 140, fontSize: 15 }} disabled={true}>
                                            download
                                        </button>
                                    }
                                    <button onClick={this.handleback} className="btn btn-primary my_custom_orderPage_btns m-2" style={{ width: 140, fontSize: 15 }} >
                                        back
                                    </button>
                                </div>
                            </div> */}
                                {this.renderTable(currentRecords)}
                                {blockCalendarList.length > 0 ? (
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={this.updateItem}
                                    />
                                ) : (
                                    <></>
                                )}
                                {/* {
                                    selectedSlotsList.length > 0 &&
                                    <div className="card mb-3" style={{ backgroundColor: 'rgb(240,240,240)' }}>
                                        <div className="card-body">
                                            <label style={{ fontSize: '20px', marginBottom: '5px', color: 'rgb(35, 35, 35)' }}>Selected Slots List</label>
                                            {this.renderSelectedTable()}
                                        </div>
                                    </div>
                                } */}
                                <div style={{ width: '100%', textAlign: 'right' }}>
                                    <button class="btn save_btn mr-1" disabled={selectedList.length == 0}
                                        onClick={this.toggleModal}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Modal size="lg mt-5" show={isOpen} >
                        <Modal.Header>
                            <Modal.Title><h4 class="modal-title modal_title_text"><strong>
                                Are you Sure you want to Unblock Selected Slots?</strong></h4></Modal.Title>
                            <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.toggleModal()} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                        </Modal.Header>
                        <Modal.Footer>
                            <div class="row">
                                <div class="col-md-12">
                                    <a style={{ width: '75px' }}
                                        onClick={this.handleunblockCalender}
                                        class="btn btn-success mr-1">Yes</a>
                                    <a style={{ width: '75px' }}
                                        onClick={() => this.toggleModal()}
                                        class="btn btn-warning ml-1">No</a>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </main >
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_block_calendar_list_action, unblock_calender_action })(UnblockCalenderList))